<style type="text/css" media="screen">
#map{
	width: 100%;
	height: 600px;
}
</style>

<template>
	<div>

		<div id="map">


		</div>
	</div>
</template>
<script type="text/javascript">
import $Scriptjs from 'scriptjs';
export default{
	data(){
		return {
			map:null,
			marker_1:null,
			marker_2:null,
			directionsService:null,
			directionsRenderer:null,
			center:{
				lat:21.2514,
				lng:81.6296
			},
			dest:{},
			origin:{
				lat:21.2514,
				lng:81.6296
			},
			location:"",
			theKeyword:"",
			delivery_agent_id:null,
		}
	},
	mounted(){
		console.log(this.$route.query)
		this.dest={
			lat:parseFloat(this.$route.query.r_lat),
			lng:parseFloat(this.$route.query.r_lng)
		}
		this.delivery_agent_id=this.$route.query.d_agent_id

		$Scriptjs('https://maps.googleapis.com/maps/api/js?key='+this.$keys.GOOGLE_PLACES_API_KEY+'&libraries=geometry,places',()=>{
			this.intMap();
			// this.updateMarker(this.center);
		});
	},
	methods:{
		intMap(){
			this.directionsService = new window.google.maps.DirectionsService();
			this.directionsRenderer = new window.google.maps.DirectionsRenderer();


			this.map = new window.google.maps.Map(document.getElementById("map"),{
				center: this.center,
				// zoom: 7,
				mapTypeId: "terrain",

			});
			this.directionsRenderer.setMap(this.map);
			this.directionsRenderer.setOptions( { suppressMarkers: true } );


			this.ready();


			// document.getElementById("start").addEventListener("change", this.onChangeHandler);
			// document.getElementById("end").addEventListener("change", this.onChangeHandler);


		},
		onChangeHandler(){
			this.calculateAndDisplayRoute(this.directionsService, this.directionsRenderer);

		},
		calculateAndDisplayRoute(directionsService, directionsRenderer) {
			this.directionsService.route(
			{
				origin:this.origin,
				destination: this.dest,
				travelMode: window.google.maps.TravelMode.DRIVING,
			},
			(response, status) => {
				if (status === "OK") {
					directionsRenderer.setDirections(response);
					this.addMarker(this.dest)
					this.updateMarker(this.origin)
				} else {
					window.alert("Directions request failed due to " + status);
				}
			}
			);
			// console.log(this.directionsService)
		},
		addMarker(position) {
			const retailer_image = {
				url:"https://medx-prod-media-bucket.s3.ap-south-1.amazonaws.com/map-marker+2-01.png",
				size: new window.google.maps.Size(64, 64),
				// origin: new window.google.maps.Point(0, 0),
				// anchor: new window.google.maps.Point(32, 64),
			};


			let map =this.map
			this.marker=new window.google.maps.Marker({
				position: position,
				map,
				// icon: retailer_image,

				// title: "Hello World!",
			});
		},
		updateMarker(position) {
			const marker_image = {
				url:"https://medx-prod-media-bucket.s3.ap-south-1.amazonaws.com/map-marker+2-01.png",
				size: new window.google.maps.Size(64, 64),
				// origin: new window.google.maps.Point(0, 0),
				// anchor: new window.google.maps.Point(32, 64),
			};

			if (!this.marker_2) {
				console.log("new marker")
				this.marker_2 = new window.google.maps.Marker({
					map: this.map,
					icon: marker_image,
				});
			}
			console.log("update marker")
			let latLng=new window.google.maps.LatLng(position.lat, position.lng);
			this.marker_2.setPosition(latLng);
		},

		/* polling Apis*/ 
		ready: function () {
			this.getDeliveryAgentLocation()
			setInterval(function () {
				this.getDeliveryAgentLocation()
			}.bind(this), 5000); 
		},

		getDeliveryAgentLocation(){
			this.$store.dispatch('setPageLoader', true)
			const self=this
			let params={
				id:this.delivery_agent_id,
			};
			const successHandler = (response) => {
				if (response.data.success){
					if(response.data.agent_latitude){
						self.origin.lat=parseFloat(response.data.agent_latitude)
						self.origin.lng=parseFloat(response.data.agent_longitude)
					}
					this.onChangeHandler();
				}
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)
			};

			self.request_GET( self,self.$urls.GET_AGENT_LOCATION,params,successHandler,null,null,finallyHandler)
		},

	}

}
</script>	